import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import JumboDemoCard from '@jumbo/components/JumboDemoCard';
import Div from '../Div';

const ExcelFileUpload = ({ onFileUpload }) => {
  const [fileUploaded, setFileUploaded] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    onFileUpload(file);
    setFileUploaded(true);
  }, [onFileUpload]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: '.xlsx, .xls, .csv',
  });

  return (
    <div style={{display:'block',width:'100%',textAlign: 'center'}}>
        <Div sx={{cursor: 'pointer',display:'block',width:'100%'}}>
          <Div  sx={{display:'block',width:'100%'}} {...getRootProps()} className={`dropzone ${fileUploaded ? 'uploaded' : ''}`}>
            <input {...getInputProps()} />
            {fileUploaded ? (
              <Div sx={{display:'block',width:'100%'}}>
                <CheckCircleOutlineIcon fontSize="large" style={{ color: 'green' }} />
                <p>Click To File Upload</p>
              </Div>
            ) : isDragActive ? (
              <Div sx={{display:'block',width:'100%'}}>
                <CloudUploadIcon fontSize="large" style={{ color: 'blue' }} />
                <p>Drop the Excel file here</p>
              </Div>
            ) : (
              <Div sx={{display:'block',width:'100%'}}>
                <CloudUploadIcon fontSize="large" style={{ color: 'gray' }} />
                <p>Drag & drop an Excel file here, or click to select one</p>
              </Div>
            )}
          </Div>
        </Div>
    </div>
  );
};

export default ExcelFileUpload;
